export default {
      id: "icon-arrow-back-usage",
      viewBox: "0 0 12.58 21.5",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-arrow-back",
      toString: function () {
        return this.url;
      }
    }